export default __webpack_public_path__ + "static/media/activity.7a48fe87.svg";